/**
 * @see ./config.example.js
 */
import NativeMaterialScrollTop from './components/native-material-scrolltop'
import NativeSlider from './components/native-slider'
import ObservableViewMetrics from './components/observable-view-metrics'
import PhoneNumberInputSanitizer from './components/phone-number-input-sanitizer'

export default {
  initializerOpts: {
    mountedModulePrefix: '__'
  },
  modules: {
    nativeSlider: {
      module: NativeSlider
    },
    ObservableViewMetrics: {
      module: ObservableViewMetrics
    },
    PhoneNumberInputSanitizer: {
      module: PhoneNumberInputSanitizer
    },
    nativeMaterialScrollTop: {
      module: NativeMaterialScrollTop,
      listenerOpts: { passive: true }
    }
  }
}
